// Full page loads (leaving the single-page app, or reloading it on purpose)
// go through these two functions instead of touching window.location
// directly, so a test can replace them. jsdom 21+ (Jest 30) makes
// window.location impossible to fake: `delete window.location` is ignored,
// and a test that assigns a stand-in silently keeps the real one.
//
// `goTo(url)` is exactly `window.location.assign(url)`, which is also what
// `window.location.href = url` does. `replaceWith(url)` leaves no history
// entry behind, for pages the Back button should not return to.

export function goTo(url) {
  window.location.assign(url);
}

export function replaceWith(url) {
  window.location.replace(url);
}

export function reloadPage() {
  window.location.reload();
}
